var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawAiAnswersUxgx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 731.503,
    height: 762.51,
    viewBox: "0 0 731.503 762.51",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-682 -144.945)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173.984 327.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.679,283.842,181.466,294.1V249.166h28.322Z",
    transform: "translate(-147.152 -187.451)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.101,
    cy: 31.102,
    rx: 31.101,
    ry: 31.102,
    transform: "translate(7.073 11.95)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.108,245.583l-4.372,5.312-7.9-13.83s-10.089.518-10.089-6.964-9.263-7.692-9.263-7.692-13.1-22.882,14.04-16.858c0,0,18.834-12.907,28.194-1.879,0,0,28.712,14.461,20.5,39.643l-13.652,25.943-3.093-5.878s1.878-24.664-14.364-17.8Z",
    transform: "translate(-160.631 -200.554)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.129,
    height: 35.645,
    transform: "translate(48.975 522.077)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.339,674.68c4.3.4,25.8,2.081,26.876-2.843a21.06,21.06,0,0,0-.667-9.9c-2.065-20.554-2.827-20.793-3.288-20.936-.731-.206-2.875.794-6.338,3.034l-.222.143-.048.254c-.064.318-1.6,7.863-8.879,6.719-4.988-.794-6.608-1.89-7.132-2.43a2.92,2.92,0,0,0,1.318-1.112,3.887,3.887,0,0,0,.286-3.209,51.1,51.1,0,0,0-3.86-8.673l-.318-.572-28.56,19.268-17.632,5.035a4.534,4.534,0,0,0-2.939,2.605h0a4.547,4.547,0,0,0,1.144,5.131c3.209,2.875,9.562,7.815,16.25,8.419,1.779.159,4.13.222,6.767.222,11.04,0,27.13-1.144,27.257-1.16h-.016Z",
    transform: "translate(-170.584 -96.546)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.644,
    height: 25.129,
    transform: "matrix(-0.637, -0.771, 0.771, -0.637, 130.735, 512.045)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.83,632.7c3.558-2.446,21.205-14.836,18.9-19.315a21.065,21.065,0,0,0-6.83-7.2c-14.693-14.518-15.439-14.217-15.884-14.026-.7.3-1.7,2.446-2.954,6.37l-.079.238.127.222c.159.286,3.78,7.084-2.557,10.833-4.352,2.573-6.306,2.748-7.037,2.669a3.051,3.051,0,0,0,.318-1.7,3.816,3.816,0,0,0-1.843-2.653,51.3,51.3,0,0,0-8.514-4.225l-.6-.238-9.721,33.056L101.78,651.857a4.565,4.565,0,0,0-.6,3.892h0a4.544,4.544,0,0,0,4.162,3.224c4.3.175,12.342-.079,17.886-3.876,1.461-1,3.32-2.446,5.353-4.13,8.5-7.037,20.173-18.172,20.268-18.267h-.016Z",
    transform: "translate(-2.976 -106.684)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.751,399.241h86.188l-19.156,284.9H197.048l-38.313-284.9h.016Z",
    transform: "translate(-151.329 -152.107)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.685,414.935l-17.552-15.694,8.784,156.7,98.149,93.369,24.478-20.221-57.2-74.212Z",
    transform: "translate(-114.711 -152.107)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.932,264.921l42.57-6.91,13.216,23.112a156.96,156.96,0,0,1,19.538,97.006l-6.687,54.4H152.38l17.552-167.6h0v-.016Z",
    transform: "translate(-144.958 -185.368)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.419,449.685c-1.763,8.784,1.525,16.806,7.323,17.918,5.814,1.1,11.945-5.131,13.708-13.931a21.692,21.692,0,0,0-.381-10.579l6.989-37.344-18.267-2.843-4.94,37.122a21.979,21.979,0,0,0-4.432,9.674h0v-.016Z",
    transform: "translate(-104.88 -151.244)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.708,469.039l26.828-82.885v-.127L198.4,300.68a25.981,25.981,0,1,0-51,9.372l17.9,71.591-4.273,81.249,20.7,6.147Z",
    transform: "translate(-99.947 -180.717)",
    fill: "#6c63ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M731.5,668.455H0v-2H731.5Z",
    transform: "translate(682 239)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.177,547.444c0-5.36-1.8-9.71-4.01-9.72H356.677c-2.22.01-4.01,4.36-4.02,9.72V768.087a2,2,0,0,1-1.809,1.994q-2.425.233-4.851.433c-.04,0-.08.01-.12.01-.88.08-1.76.14-2.64.21h-.01q-.679-1.255-1.342-2.533a2.012,2.012,0,0,1-.228-.929V534.834c0-1.48.06-2.97.16-4.44a56.879,56.879,0,0,1,.75-6.02c1.69-9.29,5.51-15.58,9.85-15.6h175a4.683,4.683,0,0,1,1.84.39,7.173,7.173,0,0,1,2.27,1.59,14.073,14.073,0,0,1,2.23,3.05c2.14,3.77,3.67,9.39,4.21,15.93,0,.06.01.12.01.18.14,1.62.21,3.27.2,4.92l.14,21.43.09,12.78.27,40.1.1,14.24.44,146.2h0a2,2,0,0,1-2,2h-8.04a2,2,0,0,1-2-2Z",
    transform: "translate(425.613 134.871)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.2,321.74,229.622,372.7l-7.4,8.106h-5.339l22-92.646,1.088,15.739v.011Z",
    transform: "translate(592.906 262.455)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M464.232,501.4l-67.94-.43-6.03-.04-4.3-.03-5.01-.03h-.04a2.764,2.764,0,0,0-1.94.8l-8.46,8.46a2.184,2.184,0,0,0-.45.64.981.981,0,0,0-.13.22,2.824,2.824,0,0,0,2.54,3.94h88.01a2.8,2.8,0,0,0,2.52-1.6l.69-1.5,1.42-3.05,1.61-3.44a2.741,2.741,0,0,0,.26-1.17,2.785,2.785,0,0,0-2.75-2.77Z",
    transform: "translate(425.613 134.871)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463.692,511.825,463,513.331a2.8,2.8,0,0,1-2.513,1.6H372.471a2.819,2.819,0,0,1-2.536-3.937.84.84,0,0,1,.128-.22Z",
    transform: "translate(425.613 134.871)",
    opacity: 0.17,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.975,303.894v.011l-18.842,76.9h-4.25l22-92.646Z",
    transform: "translate(592.906 262.455)",
    opacity: 0.17,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M430.392,445.568l-26.67-202.91a2.892,2.892,0,0,0-1.1-1.92l-18.36-22.98-1.65-1.27a2.929,2.929,0,0,0-2.14-.57l-2.76.37a2.894,2.894,0,0,0-2.5,3.24h0l27.64,210.24v.01l1.69,12.86,2.01,15.27v.02l3.12,23.76a2.832,2.832,0,0,0,1.25,2.02,2.873,2.873,0,0,0,2.33.42l1.75-.44a2.939,2.939,0,0,0,1.66-1.14l.78-1.11.36-.52,12.08-33.3A2.876,2.876,0,0,0,430.392,445.568Z",
    transform: "translate(425.613 134.871)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.258,217.759l33.548,263.164-.364.515-.777,1.107a2.929,2.929,0,0,1-1.66,1.141l-1.753.441a2.906,2.906,0,0,1-3.579-2.438L375.217,219.531a2.9,2.9,0,0,1,2.493-3.248l2.767-.364a2.855,2.855,0,0,1,2.131.573Z",
    transform: "translate(425.613 134.871)",
    opacity: 0.17,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.951,97.7l17.8,25.411,21.16,161-11.472,22.759Z",
    transform: "translate(592.906 262.455)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406.892,353.983v0a.94.94,0,0,1,1.025-.819l154.281.411a.938.938,0,0,1,1.018.822v0a.94.94,0,0,1-1.025.819l-154.281-.411a.938.938,0,0,1-1.018-.822Z",
    transform: "translate(425.613 134.871)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M606.962,409.841h-61.1a6.183,6.183,0,0,1-6.176-6.176v-80.9a6.183,6.183,0,0,1,6.176-6.176h61.1a6.183,6.183,0,0,1,6.176,6.176v80.9a6.183,6.183,0,0,1-6.176,6.176Z",
    transform: "translate(425.613 134.871)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M602.667,404.693H550.156a5.49,5.49,0,0,1-5.484-5.484V327.215a5.49,5.49,0,0,1,5.484-5.484h52.511a5.49,5.49,0,0,1,5.484,5.484v71.994a5.49,5.49,0,0,1-5.484,5.484Z",
    transform: "translate(425.613 134.871)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M597.429,335.413H555.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,0,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#6c63ff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M597.429,340.83H555.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.615,346.247H555.395a1.371,1.371,0,0,1,0-2.742h18.221a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M597.429,357.592H555.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,0,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M597.429,363.009H555.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#e4e4e4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M573.615,368.426H555.395a1.371,1.371,0,0,1,0-2.742h18.221a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#e4e4e4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M597.429,379.772H555.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,0,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#e4e4e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M597.429,385.189H555.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#e4e4e4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M573.615,390.606H555.395a1.371,1.371,0,0,1,0-2.742h18.221a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#e4e4e4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.746,174.459l163.915-140.2h.26v2.058h.5L233.085,176.023Z",
    transform: "translate(592.906 262.455)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M615.962,195.841h-61.1a6.183,6.183,0,0,1-6.176-6.176v-55.9a6.183,6.183,0,0,1,6.176-6.176h61.1a6.183,6.183,0,0,1,6.176,6.176v55.9a6.183,6.183,0,0,1-6.176,6.176Z",
    transform: "translate(425.613 134.871)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M611.667,190.693H559.156a5.49,5.49,0,0,1-5.484-5.484V138.215a5.49,5.49,0,0,1,5.484-5.484h52.511a5.49,5.49,0,0,1,5.484,5.484v46.994a5.49,5.49,0,0,1-5.484,5.484Z",
    transform: "translate(425.613 134.871)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M606.429,146.413H564.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,0,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M606.429,151.83H564.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M582.615,157.247H564.395a1.371,1.371,0,0,1,0-2.742h18.221a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M606.429,168.592H564.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,0,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#e4e4e4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M606.429,174.009H564.395a1.371,1.371,0,0,1,0-2.742h42.034a1.371,1.371,0,0,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#e4e4e4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M582.615,179.426H564.395a1.371,1.371,0,0,1,0-2.742h18.221a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(425.613 134.871)",
    fill: "#e4e4e4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M489.035,460.742h-3.079a10.415,10.415,0,0,1-10.4-10.4v-2.585c0-6.4,1.213-11.763,3.606-15.933a83.815,83.815,0,0,1,10.1-13.566,59.784,59.784,0,0,0,6.865-8.275,13.919,13.919,0,0,0,2.168-7.7c0-6.422-4.184-9.545-12.792-9.545a51.943,51.943,0,0,0-14.1,2.116,11.87,11.87,0,0,1-15.128-11.414v-5.233a11.643,11.643,0,0,1,6.869-10.672,68.154,68.154,0,0,1,50.328-.439,39.9,39.9,0,0,1,16.915,12.819,30.874,30.874,0,0,1,6.067,18.712,30.433,30.433,0,0,1-5.866,18.714,106.977,106.977,0,0,1-16.4,16.712,116.889,116.889,0,0,0-10.516,9.907,18.288,18.288,0,0,0-4.372,8.14,10.375,10.375,0,0,1-10.253,8.641Z",
    transform: "translate(725.398 -217.546)",
    fill: "#6c63ff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M490.077,535.971h-.406a19.281,19.281,0,1,1,0-38.562h.406a19.281,19.281,0,1,1,0,38.562Z",
    transform: "translate(722.645 -243.853)",
    fill: "#6c63ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAiAnswersUxgx);
export default __webpack_public_path__ + "static/media/undraw_ai-answers_uxgx.48948ae55430da7140ad1d4e5eac03d2.svg";
export { ForwardRef as ReactComponent };